class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Setup elements
    this.closeBtn = this.querySelector('[data-close]');
    this.cartDialog = document.getElementById('cartDialog');
    this.simBtn = this.querySelectorAll('[data-cart-sim-btn]');

    // Bind event handlers
    this.closeBtn.addEventListener('click', this.handleClose.bind(this));
    this.simBtn.forEach((btn) => {
      btn.addEventListener('click', this.handleSimBtnClick.bind(this));
    });
  }

  handleSimBtnClick(e) {
    e.preventDefault();
    document.body.dispatchEvent(new CustomEvent('open-dialog:sim'));
  }

  handleClose(e) {
    e.preventDefault();
    this.cartDialog.close();
  }
}

customElements.define('cart-drawer', CartDrawer);
